<ng-container [ngSwitch]="bookingStore.bookingPlansLoadedState$ | async">
  <div
    class="flex flex-col gap-[24px] lt-md:gap-[16px]"
    *ngSwitchCase="BookingPlansLoadingState.Loaded"
  >
    <ng-container
      *ngIf="
        (bookingStore.error$ | async) === noInstallationsError;
        then bookingPlansError;
        else bookingPlans
      "
    ></ng-container>
    <ng-template #bookingPlans>
      <ng-container *ngIf="bookingStore.subscriptionsPlans$ | async as bookingPlans">
        <div *ngIf="isLegacyDevice" class="legacy-devices-note legacy-devices-frame">
          <h2 class="legacy-devices-note-title">
            {{ '+BOOKING.LEGACY_DEVICES_NOTE.TITLE' | translate }}
          </h2>
          <vi-text class="legacy-devices-note-description" size="medium">
            {{ '+BOOKING.LEGACY_DEVICES_NOTE.DESCRIPTION' | translate }}
          </vi-text>
        </div>

        <div class="plans-wrapper">
          <app-booking-plans-package-content
            [isLegacyDevice]="isLegacyDevice"
          ></app-booking-plans-package-content>

          <div class="prices-row gt-md:!flex flex-row !hidden">
            <div class="flex-[100%] max-w-[60%]"></div>
            <div
              class="price-details flex flex-col justify-start items-center flex-[100%] max-w-[20%]"
            >
              {{ bookingPlans?.basic?.price.price }} {{ bookingPlans?.basic?.price.currency }}
              <p class="price-info">{{ '+BOOKING.PLAN.BASIC_PACKAGE_DESCRIPTION' | translate }}</p>
            </div>
            <div class="pro-package-price flex-[100%] max-w-[20%]">
              <ng-container *ngTemplateOutlet="proPackagePrice"></ng-container>
            </div>
          </div>

          <div class="pro-package-frame">
            <div class="pro-frame-subtitle !hidden gt-md:!block">
              {{ '+BOOKING.PLAN.BEST_SELLING_PACKAGE' | translate }}
            </div>
          </div>
        </div>

        <div class="pro-package-panel !hidden lt-lg:!block">
          <div class="pro-frame-subtitle">
            {{ '+BOOKING.PLAN.BEST_SELLING_PACKAGE' | translate }}
          </div>
          <ng-container *ngTemplateOutlet="proPackagePrice"></ng-container>
        </div>

        <ng-template #proPackagePrice>
          <div class="price-details flex flex-col justify-start items-center">
            <div
              class="price-details-section flex flex-col justify-start items-center"
              [ngClass]="{ 'legacy-devices-frame': isLegacyDevice }"
            >
              <span
                >{{
                  isLegacyDevice
                    ? (bookingPlans?.proLegacy?.price.price / 12).toFixed(2)
                    : ((bookingPlans?.pro?.price.price / 12).toFixed(2) | number: '1.2-2':'de-DE')
                }}
                {{ bookingPlans?.pro?.price.currency }}
                <mat-icon
                  data-at-price-info-icon
                  matTooltipClass="data-at-price-info"
                  inline="true"
                  [ngClass]="{ 'yellow-icon': isLegacyDevice }"
                  [matTooltip]="'+BOOKING.PRICE.PRICE_TOOLTIP' | translate"
                  >info_outline</mat-icon
                >
              </span>
              <p data-at-monthly-price class="price-info price-info-bold">
                {{ '+BOOKING.PRICE.MONTHLY_PLUS_VAT' | translate }}
              </p>
              <div class="flex flex-row flex-wrap gap-[4px] justify-center items-stretch">
                <p data-at-annual-price class="price-info">
                  {{ '+BOOKING.PRICE.ANNUAL_PRICE' | translate }}
                  {{
                    isLegacyDevice
                      ? bookingPlans?.proLegacy?.price.price
                      : (bookingPlans?.pro?.price.price | number: '1.2-2':'de-DE')
                  }}
                  {{ bookingPlans?.pro?.price.currency }}
                </p>
              </div>
            </div>
            <div class="price-details-section flex flex-col md:flex-row sm:flex-row gap-[16px]">
              <button
                data-at-buy-Pro-button
                mat-raised-button
                color="primary"
                (click)="selectPlan(BookingPlans.Pro)"
                gtm="onSelect"
                gtmAction="Pro package"
                gtmCategory="booking"
                [disabled]="!(remoteConfigStore.isBookingProButtonEnabled$ | async)"
              >
                {{ '+BOOKING.OVERVIEW.BUTTON.BUY_PRO' | translate }}
              </button>
              <button
                data-at-buy-Trial-button
                mat-stroked-button
                (click)="selectPlan(BookingPlans.Trial)"
                gtm="onSelect"
                gtmAction="Test for free Pro package"
                gtmCategory="booking"
                [disabled]="!(bookingStore.trialSubscriptions$ | async)?.remaining"
              >
                {{ '+BOOKING.OVERVIEW.BUTTON.TEST_FOR_FREE' | translate }}
              </button>
            </div>
            <p class="price-info">
              {{ '+BOOKING.PRICE.TEST_FOR_FREE' | translate }}
              <mat-icon
                data-at-test-plan-info-icon
                matTooltipClass="data-at-test-plan-conditions"
                inline="true"
                [matTooltip]="'+BOOKING.PRICE.TEST_FOR_FREE_TOOLTIP' | translate"
                >info_outline</mat-icon
              >
            </p>
            <p data-at-remaining-devices class="price-info">
              {{ '+BOOKING.DEVICES.REMAINING_DEVICES' | translate }}
              {{ (bookingStore.trialSubscriptions$ | async)?.remaining }} /
              {{ (bookingStore.trialSubscriptions$ | async)?.total }}
            </p>
          </div>
        </ng-template>
        <ng-container *ngIf="authStore.isCompanyFromGermany$ | async">
          <div class="external-advertises">
            <app-additional-services></app-additional-services>
          </div>
        </ng-container>

        <div
          data-at-plus-section
          *ngIf="!(authStore.isCompanyFromNetherlandsOrPoland$ | async)"
          class="plus-package-panel"
        >
          <div class="flex flex-row">
            <img src="assets/img/emergency-illustration.svg" class="xs:!hidden" />
            <div class="flex flex-row lt-lg:flex-col">
              <div class="flex flex-col">
                <h3 class="plus-package-panel-title">
                  {{ '+BOOKING.PLAN.PLUS.PANEL.TITLE' | translate }}
                </h3>
                <vi-text class="plus-package-panel-title">
                  {{ '+BOOKING.PLAN.PLUS.PANEL.SUBTITLE' | translate }}
                </vi-text>
                <div class="plus-package-features-list">
                  <p>{{ '+BOOKING.PLAN.FEATURE.QUICK_CHECK_DASHBOARD' | translate }}</p>
                  <p>{{ '+BOOKING.PLAN.FEATURE.GUIDED_COMMISSIONING' | translate }}</p>
                  <p>{{ '+BOOKING.PLAN.FEATURE.ERROR_LIST' | translate }}</p>
                  <p>{{ '+BOOKING.PLAN.FEATURE.BASIC_PARAMETERS' | translate }}</p>
                  <p>{{ '+BOOKING.PLAN.FEATURE.EXTENDED_PARAMETERS' | translate }}</p>
                  <p>{{ '+BOOKING.PLAN.FEATURE.PARAMETER_COMPARISION' | translate }}</p>
                  <p>{{ '+BOOKING.PLAN.FEATURE.SYSTEM_OVERVIEW' | translate }}</p>
                  <p>{{ '+BOOKING.PLAN.FEATURE.TRENDING' | translate }}</p>
                  <p>{{ '+BOOKING.PLAN.FEATURE.GUIDED_TROUBLESHOOTING' | translate }}</p>
                </div>
              </div>
              <div data-at-plus-price class="price-details">
                <div class="package-name lt-lg:!hidden">
                  {{ '+BOOKING.PLAN.PLUS_PACKAGE' | translate }}
                </div>
                <div
                  class="flex flex-col md:flex-row-reverse md:gap-[24px] justify-center items-stretch"
                >
                  <div>
                    {{
                      isLegacyDevice
                        ? bookingPlans?.plusLegacy?.price.price
                        : (bookingPlans?.plus?.price.price | number: '1.2-2':'de-DE')
                    }}
                    {{ bookingPlans?.plus?.price.currency }}
                    <mat-icon
                      inline="true"
                      [matTooltip]="'+BOOKING.PRICE.PRICE_TOOLTIP' | translate"
                      >info_outline</mat-icon
                    >
                    <p class="price-info price-info-bold">
                      {{ '+BOOKING.PRICE.EXCLUDING_VAT' | translate }}
                    </p>
                  </div>
                  <button
                    data-at-buy-Plus-button
                    class="buy-plus-button"
                    mat-stroked-button
                    (click)="selectPlan(BookingPlans.Plus)"
                    gtm="onSelect"
                    gtmAction="Plus package"
                    gtmCategory="booking"
                    [disabled]="!(remoteConfigStore.isBookingPlusButtonEnabled$ | async)"
                  >
                    {{ '+BOOKING.OVERVIEW.BUTTON.BUY_PLUS' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <app-booking-plans-spec data-at-pro-plus-section></app-booking-plans-spec>

        <div class="references flex flex-col gap-[16px]">
          <p>{{ '+BOOKING.OVERVIEW.PAYMENT.PAYMENT_REFERENCE' | translate }}</p>
          <p>{{ '+BOOKING.OVERVIEW.PAYMENT.PAYMENT_REFERENCE_SECOND' | translate }}</p>
        </div>
      </ng-container>
    </ng-template>
    <ng-template #bookingPlansError>
      <div
        class="error-container flex flex-col gap-[24px] lt-md:gap-[16px] justify-start items-center"
      >
        <img class="error-img" src="assets/img/installer-error.svg" />
        <h1>{{ '+BOOKING.PLANS.ERROR.TITLE' | translate }}</h1>
        <button
          class="back-button"
          gtm="onGoToPage"
          gtmAction="Home Page"
          gtmCategory="booking"
          mat-raised-button
          color="primary"
          (click)="goToInstallations()"
        >
          <mat-icon>arrow_back</mat-icon>
          <span>{{ '+BOOKING.PLANS.ERROR.BTN' | translate }}</span>
        </button>
      </div>
    </ng-template>
  </div>

  <ng-container *ngSwitchCase="BookingPlansLoadingState.Loading">
    <vi-loader data-at-loader [isLoading]="true"></vi-loader>
  </ng-container>

  <ng-container *ngSwitchCase="BookingPlansLoadingState.Error">
    <div class="flex flex-col gap-[24px] lt-md:gap-[16px] justify-start items-center">
      <img class="error-img" src="assets/img/installer-error.svg" />
      <h1>{{ '+BOOKING.PLANS.ERROR_TIMEOUT_TITLE' | translate }}</h1>
    </div>
  </ng-container>
</ng-container>
